module.exports = __webpack_public_path__ + "img/genz.bc0f12ca.png";